import { Box } from '@mui/material'
import { C1Button } from 'c1ui'
import { OpenDialogType } from 'components/pages/task/dropdown'
import { canActOn } from 'components/pages/task/state'
import { TaskValue } from 'lib/actions/task'
import { TaskActionType } from 'pbts/c1/api/task/v1/task'
import { Dispatch, SetStateAction } from 'react'
import { FormattedMessage } from 'react-intl'
import { TaskActionButton } from './styles'

type ReassignActionButtonProps = {
    task: TaskValue
    show: boolean
    setOpenDialog: (od: OpenDialogType) => void
    setTaskActionTask: Dispatch<SetStateAction<TaskValue>>
}

export const ReassignActionButton = ({
    task,
    show,
    setOpenDialog,
    setTaskActionTask,
}: ReassignActionButtonProps): React.ReactElement | null => {
    const taskId = task.id

    if (!canActOn(task, TaskActionType.REASSIGN) || !show) {
        return null
    }

    return (
        <Box sx={TaskActionButton.item}>
            <C1Button
                key={`components_task_list_reassign_option_${taskId}`}
                variant="outlined"
                color="primary"
                onClick={(): void => {
                    setTaskActionTask(task)
                    setOpenDialog('reassign')
                }}
                disabled={!canActOn(task, TaskActionType.REASSIGN)}
            >
                <FormattedMessage id="component_task_list_reassign_option_label" defaultMessage="Reassign" />
            </C1Button>
        </Box>
    )
}
